
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 22.025V5.98a2.003 2.003 0 00-2-2.005H7c-1.105 0-2 .898-2 2.005v16.045m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7.985h1m-1 4.012h1m4-4.011h1m-1 4.01h1m-5 10.029V17.01c0-.554.448-1.003 1-1.003h2c.552 0 1 .449 1 1.003v5.014m-4 0h4","stroke":"#27B3B3","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    